/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionsCount } from "../funcs/remoteSessionsCount.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CountRemoteSessionsResult } from "../models/components/countremotesessionsresult.js";
import {
  CountRemoteSessionsRequest,
  CountRemoteSessionsSecurity,
} from "../models/operations/countremotesessions.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteSessionsCountQueryData = CountRemoteSessionsResult;

export function prefetchRemoteSessionsCount(
  queryClient: QueryClient,
  client$: GramCore,
  request: CountRemoteSessionsRequest,
  security?: CountRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionsCountQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteSessionsCountQuery(
  client$: GramCore,
  request: CountRemoteSessionsRequest,
  security?: CountRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionsCountQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionsCount({
      remoteSessionClientId: request.remoteSessionClientId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function remoteSessionsCountQueryFn(
      ctx,
    ): Promise<RemoteSessionsCountQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionsCount(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteSessionsCount(
  parameters: {
    remoteSessionClientId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessions", "count", parameters];
}
